// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3klt5","messages":"Chat_messages__2DgNH","dateDivider":"Chat_dateDivider__1W8Qr"};